/**
 * Formata um número para o padrão R$
 * @param {Number} value - Number to format
 */
export function format(value) {
  if (!value) return "0,00";

  return Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  })
    .format(value)
    .replace(/[^0-9,.]/g, "");
}



// WEBPACK FOOTER //
// ./src/utils/MoneyFormater.js